import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=5b853e3a&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./Order.vue?vue&type=style&index=0&id=5b853e3a&prod&lang=scss&scoped=true"
import style1 from "./Order.vue?vue&type=style&index=1&id=5b853e3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b853e3a",
  null
  
)

export default component.exports